import { createActionGroup, emptyProps } from '@ngrx/store';

export const userTrackingActions = createActionGroup({
  source: 'User View Tracking',
  events: {
    'Open User Profile Dialog': emptyProps(),
  },
});
